var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.949951 4.46619H2.94202V14.4744H18.8786V16.4761H0.949951V4.46619ZM8.91824 2.46454C8.91824 3.57045 8.02679 4.46619 6.92617 4.46619V8.46949C8.02679 8.46949 8.91824 9.36523 8.91824 10.4711H18.8786C18.8786 9.36523 19.7701 8.46949 20.8707 8.46949V4.46619C19.7701 4.46619 18.8786 3.57045 18.8786 2.46454H8.91824ZM13.8984 3.46537C15.5489 3.46537 16.8865 4.80947 16.8865 6.46784C16.8865 8.12621 15.5489 9.47032 13.8984 9.47032C12.248 9.47032 10.9103 8.12621 10.9103 6.46784C10.9103 4.80947 12.248 3.46537 13.8984 3.46537ZM4.9341 12.4728H22.8628V0.462891H4.9341V12.4728Z",
    fill: "#303A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.f6e0108cb8de940e977f2f7faf22f775.svg";
export { ForwardRef as ReactComponent };